import { render, staticRenderFns } from "./ManagerWrapper.vue?vue&type=template&id=01361b05&scoped=true"
import script from "./ManagerWrapper.vue?vue&type=script&lang=ts"
export * from "./ManagerWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01361b05",
  null
  
)

export default component.exports